$('.product_detail_price_categories_box').click(function(){
	$('.product_detail_price_categories_box').removeClass('active');
	$(this).addClass('active');
	price_value = $(this).attr('data-value');
	$('#price_value').html(price_value);
});


$('#minus_quantity').click(function(){
	quantity = $('#product_quantity').val();
	if(quantity > 1){
		final_quantity = quantity - 1;
		$('#product_quantity').val(final_quantity);
	}
});

$('#plus_quantity').click(function() {
    var quantity = parseInt($('#product_quantity').val());
    var final_quantity = quantity + 1;
    $('#product_quantity').val(final_quantity);
});

$('.blog_category_slide_text').click(function(){
	$('.blog_category_slide_text').removeClass('active');
	$(this).addClass('active');
});


$('.labl').click(function(){
	$('.payment_radio_content').removeClass('active');
	content = $(this).find('.payment_radio_content');
	content.addClass('active');
});


$(function () {
  $('[data-toggle="tooltip"]').tooltip()
});


$('.product_filter_btn').click(function(){
	$('.sidebar_accordion').css('transform', 'translateX(0%)');
});


$('.filter_close_btn').click(function(){
	$('.sidebar_accordion').css('transform', 'translateX(-100%)');
});


$('.search_btn').click(function(){
	$('.search_box_main').css('display', 'block');
});

$('.search_box_close_btn').click(function(){
	$('.search_box_main').css('display', 'none');
});




$('.secondry_bar_open').click(function(){
	$('.secondry_bar').toggleClass('active');
	if($('.secondry_bar').hasClass('active')){
		$('.secondry_bar_open').attr("src", "https://cdn.shopify.com/s/files/1/1442/8846/files/close.svg?v=1725279197");
	}
	else{
		$('.secondry_bar_open').attr("src", "https://cdn.shopify.com/s/files/1/1442/8846/files/menu_open.svg?v=1725278499");
	}
});


$('.main_menu_mobile_menu_pill').click(function(){
	$('.main_menu_mobile_menu_pill').removeClass('active');
	$(this).addClass('active');
});


$('.sellers_tabs_pill').click(function(){
	$('.sellers_tabs_pill').removeClass('active');
	$(this).addClass('active');
});


$('.mobile_menu').click(function(){
	$('.main_menu_mobile').css('transform', 'translateX(0%)');
});


$('.mobile_menu_close').click(function(){
	$('.main_menu_mobile').css('transform', 'translateX(-100%)');
});

$('.cart').click(function(){
	$('.sidebar_cart_main').css('transform', 'translateX(0%)');
	$('.opacity_shade_background').css('display', 'block');
});


$('.cart_close').click(function(){
	$('.sidebar_cart_main').css('transform', 'translateX(100%)');
	$('.opacity_shade_background').css('display', 'none');
});


$('.bottom_numbers').click(function(){
	$('.bottom_numbers').removeClass('active');
	$(this).addClass('active');
});
//product variant 
  document.addEventListener('DOMContentLoaded', function() {
  var variantRadios = document.querySelectorAll('[name="Size"]');

  function updateSelectedVariant() {
    var selectedVariant = document.querySelector('[name="Size"]:checked');
    if (selectedVariant) {
      document.getElementById('selected-variant').innerText = selectedVariant.value;
    }
  }

  variantRadios.forEach(function(radio) {
    radio.addEventListener('change', updateSelectedVariant);
  });

  // Initial call to display the default selected variant
  updateSelectedVariant();
});



$('.main_menu_mobile_menu_pill').click(function(){
	id = $(this).attr("id");
	$(".main_menu_mobile_tabs").removeClass("active");
	$("."+id).addClass("active");
    $('.'+id+' .main_menu_mobile_tabs_main li:first-child').addClass('active');
    $('.'+id+' .tab-content .tab-pane:first-child').addClass('in active show');
});


$('.main_menu_mobile_tabs_main li').click(function(){
  $('.main_menu_mobile_tabs_main li').removeClass('active');
  $(this).addClass('active');
  content = $(this).find('a');
  id = content.attr('href');
  console.log(content);
  $('.main_menu_mobile_tabs .tab-content .tab-pane').removeClass('in active show');
  $(id).addClass('in active show');
});

$( document ).ready(function(){
  $('.main_menu_mobile_tabs .tab-content .tab-pane:first-child').addClass('in active show');
  $('.sellers_tab_content .tab-pane:first-child').addClass('active');
});

$('.seller_tabs_inner li a').click(function(){
  $('.best_seller .tab-content .tab-pane').addClass('section_fade');
  setTimeout(function() {
    $('.best_seller .tab-content .tab-pane').removeClass('section_fade');
  }, 3000);
  id = $(this).attr('href');
  $('.sellers_tab_content .tab-pane').removeClass('active');
  $(id).addClass('active');
});


document.addEventListener("DOMContentLoaded", function() {
    var images = document.querySelectorAll('img');
    images.forEach(function(img) {
        var src = img.getAttribute('src');
        if (src) {
            var cleanSrc = src.split('?')[0];
            img.setAttribute('src', cleanSrc);
        }
    });
});


